import type { NavItem } from '@/app/nav/collect'

/** The shell already declares the four entries (`src/modules/shell/nav.ts`: hr and em "Time off", "Timesheets"). */
const nav: NavItem[] = []

export default nav
